import { Box, Image, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MapVillageV2Props } from '../../interfaces/components';
import VillageInfo from './VillageInfo';

const MapVillageV2 = ({
  top,
  bottom,
  left,
  right,
  hoverTop,
  hoverLeft,
  hoverRight,
  hoverBottom,
  text,
  src,
  hover,
  onClick,
  flexDir,
  mapInfoTopRight,
}: MapVillageV2Props) => {
  const { t } = useTranslation();
  const villageName = text.replaceAll(' ', '_').toLowerCase();
  const [showHover, setShowHover] = useState<boolean>(false);

  const onHit = () => {
    if (onClick && onClick !== undefined) {
      onClick();
    }
  };

  // eslint-disable-next-line
  // const onImageLeave = (e: any) => {
  //   const differenceWidth = window.innerWidth - e.clientX;
  //   const differenceHeight = window.innerHeight - e.clientY;
  //   // console.log('Difference', difference);

  //   if (differenceWidth > 615 || differenceHeight > 300) {
  //     setShowHover(false);
  //   }
  // };

  // // eslint-disable-next-line
  // const onVillageInfoLeave = (e: any) => {
  //   const differenceWidth = window.innerWidth - e.clientX;
  //   const differenceHeight = window.innerHeight - e.clientY;
  //   // console.log('Difference', difference);

  //   if (differenceWidth < 615 || differenceHeight < 300) {
  //     setShowHover(false);
  //   }
  // };

  return (
    <>
      <Box
        position="absolute"
        bottom={bottom}
        right={right}
        top={top}
        left={left}
        zIndex={2}
        w={['auto', 'auto', flexDir ? '40px' : '90px', flexDir ? '100px' : '170px', flexDir ? '120px' : '180px']}
        h={['auto', 'auto', '100px', flexDir ? '100px' : '76px']}
        display="flex"
        flexDir={['column', 'column', flexDir ? flexDir : 'column', flexDir ? flexDir : 'row']}
        alignItems="center"
        justifyContent="center"
        // gap="1"
        cursor="pointer"
        // onMouseEnter={() => setShowHover(true)}
        onMouseOverCapture={() => setShowHover(true)}
        userSelect="none"
        // border="1px solid red"
        // onMouseOut={() => setShowHover(false)}
        onClick={onHit}
      >
        {/* <Icon boxSize={['70px']} /> */}
        <Image
          src={src}
          alt="hover"
          w={['50px', '50px', '40px', '60px', '90px']}
          h={['50px', '50px', '40px', '60px', '90px']}
          objectFit="contain"
        />
        <Text
          fontWeight="800"
          fontSize={['12px', '12px', '9px', '12px', '14px']}
          className="copy"
          fontFamily="SangBleuBPLight"
          align={[
            'center',
            'center',
            flexDir ? (flexDir === 'column' ? 'center' : 'left') : 'center',
            flexDir ? (flexDir === 'column' ? 'center' : 'left') : 'left',
          ]}
        >
          {text}
        </Text>
      </Box>
      {showHover && (
        <Box
          position="absolute"
          bottom={hoverBottom}
          right={hoverRight}
          top={hoverTop}
          left={hoverLeft}
          display="flex"
          alignItems="center"
          gap="3"
          cursor="pointer"
          zIndex={3}
          // onMouseLeave={onImageLeave}
          onMouseOutCapture={() => setShowHover(false)}
          opacity={0.8}
          userSelect="none"
          onClick={onHit}
        >
          <Image
            src={hover}
            alt="hover"
            w={['150px', '150px', '150px', '180px', '250px']}
            h={['150px', '150px', '150px', '180px', '250px']}
            objectFit="contain"
          />
        </Box>
      )}

      <VillageInfo
        active={showHover}
        title={t(`${villageName.toLowerCase()}_title`)}
        body={t(`${villageName.toLowerCase()}_body`)}
        comingSoon={t(`${villageName.toLowerCase()}_coming_soon`) === 'true'}
        onClick={onHit}
        showOnTopRight={mapInfoTopRight}
      />
    </>
  );
};

export default MapVillageV2;
